import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from "react-toastify";
import Web3 from 'web3';
import axios from 'axios';

function Subscription() {
    const authToken = sessionStorage.getItem('authToken');
    const baseurl = process.env.REACT_APP_BASE_API_URL;
    const [dataCount, setDataCount] = useState([]);
    const [tabelLoading, setTableLoading] = useState(false);
    const [assets, setAssets] = useState([]);
    const [assetId, setAssetId] = useState("");

    const [isAccount, setAccountStatus] = useState(true);
    const [isPricing, setPricingData] = useState(false);
    const [isSubscription, setSubscriptionData] = useState(false);

    const [accountData, setAccountData] = useState([]);
    const [pricingData, setDataPricing] = useState([]);
    const [subcriptionData, setDataSubscription] = useState([]);











    useEffect(() => {

        fetchAssets(1);
    }, []);

    const handleProfileDataFetched = (data) => {

    };


    const fetchAssets = async (page) => {
        try {
            const response = await axios.get(`${baseurl}/getSubscription/data`, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                },
                validateStatus: (status) => status < 500, // Prevent throwing for 4xx
            });

            if (response.status === 429) {
                console.error("Rate limit exceeded. Please try again later.");
                return;
            }

            const depositResult = response.data;
            console.log('Static data', depositResult);
            if (depositResult.status) {
                setDataCount(depositResult.counts);
                setAccountData(depositResult.accounts);
                setDataPricing(depositResult.pricing);
                setDataSubscription(depositResult.subcription);

            }

            setTableLoading(true); // moved out for consistency
        } catch (error) {
            console.error('Fetch error:', error);
            setTableLoading(true); // Optional: still indicate loading done
        }
    };



    const handlePageChange = async (page) => {

        setTableLoading(false)
        fetchAssets(page);
    }

    const [inputAccountName, setInputAccountName] = useState("")
    const [inputActionName, setInputActionName] = useState("")
    const [inputActionAmount, setInputActionAmount] = useState("")
    const [inputQty, setInputQty] = useState("")
    const [inputDiscount, setInputDiscount] = useState(0)






    const submitAccount = async () => {

        if (!inputAccountName) {
            alert('Enter Account Name');
            return false;
        }

        const formData = new FormData();
        formData.append('account', inputAccountName);

        try {
            const response = await axios.post(`${baseurl}/media-account/create`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.data.status) {
                console.log('Success:', response.data);
                alert('Asset added successfully!');
                fetchAssets()
                // Optionally reset state here
            } else {
                console.error('Error:', response.data.message);
            }
        } catch (error) {
            console.error('Upload failed:', error);
            alert('Upload failed. Check console.');
        }

    }

    const submitPricing = async () => {

        if (!inputActionName) {
            alert('Enter Name');
            return false;
        }

        if (!inputActionAmount) {
            alert('Enter Amount');
            return false;
        }

        const formData = new FormData();
        formData.append('action_name', inputActionName);
        formData.append('amount', inputActionAmount);

        try {
            const response = await axios.post(`${baseurl}/subscription-price/create`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.data.status) {
                console.log('Success:', response.data);
                alert('Asset added successfully!');
                fetchAssets()
                // Optionally reset state here
            } else {
                console.error('Error:', response.data.message);
            }
        } catch (error) {
            console.error('Upload failed:', error);
            alert('Upload failed. Check console.');
        }

    }



    const submitSubscription = async () => {

        if (!inputQty) {
            alert('Enter Qty');
            return false;
        }

        if (!inputDiscount) {
            alert('Enter Discount');
            return false;
        }

        const formData = new FormData();
        formData.append('qty', inputQty);
        formData.append('discount', inputDiscount);

        try {
            const response = await axios.post(`${baseurl}/subscription/create`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.data.status) {
                console.log('Success:', response.data);
                alert('Asset added successfully!');
                fetchAssets()
                // Optionally reset state here
            } else {
                console.error('Error:', response.data.message);
            }
        } catch (error) {
            console.error('Upload failed:', error);
            alert('Upload failed. Check console.');
        }

    }



    const showAccount = () => {
        setAccountStatus(true);
        setPricingData(false);
        setSubscriptionData(false);
    }

    const showPrice = () => {
        setAccountStatus(false);
        setPricingData(true);
        setSubscriptionData(false);
    }

    const showSubs = () => {
        setAccountStatus(false);
        setPricingData(false);
        setSubscriptionData(true);
    }




    const deleteAccount = async (id) => {
        if (!window.confirm("Are you sure you want to delete this item?")) return;

        try {
            const response = await axios.post(
                `${baseurl}/media-account/delete`, // Replace with your actual endpoint
                { id }, // Sending ID in the request body
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${authToken}`, // Make sure `authToken` is defined
                    },
                }
            );
            if (response.data.status) {
                alert("Deleted successfully!");
                // Refresh list or remove item from state
                fetchAssets()
            } else {
                alert(response.data.message || "Failed to delete");
            }
        } catch (error) {
            console.error("Delete error:", error);
            alert("Something went wrong.");
        }
    };


    const deletePrice = async (id) => {
        if (!window.confirm("Are you sure you want to delete this item?")) return;

        try {
            const response = await axios.post(
                `${baseurl}/Subscribe-price/delete`, // Replace with your actual endpoint
                { id }, // Sending ID in the request body
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${authToken}`, // Make sure `authToken` is defined
                    },
                }
            );
            if (response.data.status) {
                alert("Deleted successfully!");
                // Refresh list or remove item from state
                fetchAssets()
            } else {
                alert(response.data.message || "Failed to delete");
            }
        } catch (error) {
            console.error("Delete error:", error);
            alert("Something went wrong.");
        }
    };


     const deleteSubs = async (id) => {
        if (!window.confirm("Are you sure you want to delete this item?")) return;

        try {
            const response = await axios.post(
                `${baseurl}/subscription/delete`, // Replace with your actual endpoint
                { id }, // Sending ID in the request body
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${authToken}`, // Make sure `authToken` is defined
                    },
                }
            );
            if (response.data.status) {
                alert("Deleted successfully!");
                // Refresh list or remove item from state
                
                fetchAssets();
            } else {
                alert(response.data.message || "Failed to delete");
            }
        } catch (error) {
            console.error("Delete error:", error);
            alert("Something went wrong.");
        }
    };




    return (
        <>
            <Header>
                <Auth onProfileDataFetched={handleProfileDataFetched} />
                <div className="main-content app-content" >
                    <div className="container-fluid">
                        {/* Page Header */}
                        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                            <div>
                                <h4 className="mb-0">Subscription Setting!</h4>

                            </div>

                        </div>
                        {/* End Page Header */}

                        {/* row */}
                        <div className="row">
                            <div className="col-xl-4 col-lg-6 col-md-6 col-xm-12" onClick={showAccount}>
                                <div className="card overflow-hidden sales-card bg-primary-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">Total Account</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                                        {dataCount ? dataCount.accounts : '0'}

                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline" />
                                </div>
                            </div>


                            <div className="col-xl-4 col-lg-6 col-md-6 col-xm-12" onClick={showPrice}>
                                <div className="card overflow-hidden sales-card bg-danger-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">Total Pricing</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                                        {dataCount ? dataCount.pricing : '0'}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline2" />
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-6 col-xm-12" onClick={showSubs}>
                                <div className="card overflow-hidden sales-card bg-success-gradient">
                                    <div className="px-3 pt-3  pb-2 pt-0">
                                        <div>
                                            <h6 className="mb-3 fs-12 text-fixed-white">Total Subscription</h6>
                                        </div>
                                        <div className="pb-0 mt-0">
                                            <div className="d-flex">
                                                <div>
                                                    <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                                        {dataCount ? dataCount.subscriptions : '0'}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="compositeline3" />
                                </div>
                            </div>
                        </div>


                        {/* row opened */}
                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-xl-12">
                                <div className="card card-table">
                                    <div className=" card-header p-0 d-flex justify-content-between mt-3">

                                    </div>
                                    <div className="table-responsive country-table">
                                        {tabelLoading ? (
                                            isAccount ? (
                                                <div>
                                                    <div>
                                                        <h3 className="card-title mb-1 text-primary">Account List</h3>
                                                        <div className="text-end">
                                                            <button className='btn btn-success btn-sm' data-bs-toggle="modal" data-bs-target="#addAssetModal" >+ Add Account</button>
                                                        </div>
                                                    </div>
                                                    <table className="table table-striped table-bordered mb-0 text-nowrap mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th className="wd-lg-25p">Name</th>
                                                                <th className="wd-lg-25p">Status</th>
                                                                <th className="wd-lg-25p">Date Time</th>
                                                                <th className="wd-lg-25p">Action</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {accountData.length > 0 ? (
                                                                accountData.map((accounts, index) => (
                                                                    <tr key={index}>
                                                                        <td>{accounts.account || 'N/A'}</td>
                                                                        <td>{accounts.status || '0'}</td>
                                                                        <td>{accounts.date_time || '0'}</td>
                                                                        <td><button className="btn btn-sm btn-danger" onClick={() => deleteAccount(accounts.id)}><i className="fa fa-trash" /></button></td>

                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="10" className="text-center">No Data Found</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : isPricing ? (
                                                <div>
                                                    <div>
                                                        <h3 className="card-title mb-1 text-primary">Pricing List</h3>
                                                        <div className="text-end">
                                                            <button className='btn btn-success btn-sm' data-bs-toggle="modal" data-bs-target="#pricingModal" >+ Add Pricing</button>
                                                        </div>
                                                    </div>
                                                    <table className="table table-striped table-bordered mb-0 text-nowrap mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th className="wd-lg-25p">Method</th>
                                                                <th className="wd-lg-25p">Pricing</th>
                                                                <th className="wd-lg-25p">Date Time</th>
                                                                <th className="wd-lg-25p">Action</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {pricingData.length > 0 ? (
                                                                pricingData.map((dataPricing, index) => (
                                                                    <tr key={index}>
                                                                        <td>{dataPricing.action_name || 'N/A'}</td>
                                                                        <td>$ {dataPricing.amount || '0'}</td>
                                                                        <td>{dataPricing.date_time || '0'}</td>
                                                                        <td><button className="btn btn-sm btn-danger" onClick={()=>deletePrice(dataPricing.id)}><i className="fa fa-trash" /></button></td>

                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="10" className="text-center">No Data Found</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            ) : isSubscription ? (
                                                <div>
                                                    <div>
                                                        <h3 className="card-title mb-1 text-primary">Quantity & Discount</h3>
                                                        <div className="text-end">
                                                            <button className='btn btn-success btn-sm' data-bs-toggle="modal" data-bs-target="#discountModal" >+ Add Qty & Discouunt</button>
                                                        </div>
                                                    </div>
                                                    <table className="table table-striped table-bordered mb-0 text-nowrap mt-3">
                                                        <thead>
                                                            <tr>
                                                                <th className="wd-lg-25p">Quantity</th>
                                                                <th className="wd-lg-25p">Discount</th>
                                                                <th className="wd-lg-25p">Date Time</th>
                                                                <th className="wd-lg-25p">Action</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {subcriptionData.length > 0 ? (
                                                                subcriptionData.map((dataSubs, index) => (
                                                                    <tr key={index}>
                                                                        <td>{dataSubs.qty || 'N/A'}</td>
                                                                        <td> {dataSubs.discount || '0'} %</td>
                                                                        <td>{dataSubs.date_time || '0'}</td>
                                                                        <td><button className="btn btn-sm btn-danger" onClick={()=>deleteSubs(dataSubs.id)}><i className="fa fa-trash" /></button></td>

                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="10" className="text-center">No Data Found</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>

                                            ) : null
                                        ) : (
                                            <div className="text-center">
                                                <div className="d-flex justify-content-center mb-4">
                                                    <div className="spinner-border" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* /row */}

                    </div>
                </div>

                <div className="modal fade" id="addAssetModal" tabIndex="-1" aria-labelledby="addAssetModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title" id="addAssetModalLabel">Add Rank</h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>

                            <div className="modal-body">
                                <div className="row">

                                    <div className="col-md-12 mt-4">
                                        <label className="form-label">Account Name</label>
                                        <input type="text" className="form-control" name="accountName" value={inputAccountName} onChange={(e) => setInputAccountName(e.target.value)} placeholder="Enter Account Name like Facebook" defaultValue="0" />
                                    </div>


                                    <div className="col-md-12 mt-4 text-end">
                                        <button type="submit" className="btn btn-success" onClick={submitAccount}>Submit</button>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="modal fade" id="pricingModal" tabIndex="-1" aria-labelledby="pricingModaldata" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title" id="pricingModaldata">Add Pricing</h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>

                            <div className="modal-body">
                                <div className="row">

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Action</label>
                                        <input type="text" className="form-control" name="accountName" value={inputActionName} onChange={(e) => setInputActionName(e.target.value)} placeholder="Follow , like , subscribe" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Amount</label>
                                        <input type="text" className="form-control" name="accountName" value={inputActionAmount} onChange={(e) => setInputActionAmount(e.target.value)} placeholder="Enter amount" defaultValue="0" />
                                    </div>


                                    <div className="col-md-12 mt-4 text-end">
                                        <button type="submit" className="btn btn-success" onClick={submitPricing}>Submit</button>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="modal fade" id="discountModal" tabIndex="-1" aria-labelledby="pricingModaldata" aria-hidden="true">
                    <div className="modal-dialog modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h6 className="modal-title" id="pricingModaldata">Add Qty & Discount</h6>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>

                            <div className="modal-body">
                                <div className="row">

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Qty</label>
                                        <input type="text" className="form-control" name="accountName" value={inputQty} onChange={(e) => setInputQty(e.target.value)} placeholder="Enter Account Name like Facebook" defaultValue="0" />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <label className="form-label">Disacount %</label>
                                        <input type="text" className="form-control" name="accountName" value={inputDiscount} onChange={(e) => setInputDiscount(e.target.value)} placeholder="Enter Account Name like Facebook" defaultValue="0" />
                                    </div>


                                    <div className="col-md-12 mt-4 text-end">
                                        <button type="submit" className="btn btn-success" onClick={submitSubscription}>Submit</button>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </div>
                </div>





                <ToastContainer />
            </Header>


            <Footer />

        </>
    )
}

export default Subscription